import { makeStyles } from '@mui/styles';

/**
 * NOTE : This File needs to be deleted, and never be used again.
 * This exists in the codebase to support the old dashboard design.
 */
export default makeStyles((theme) => ({
	accordionStyle: {
		borderBottom: '2px solid #fff',
		borderRadius: '2px',
		'& > div': {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			borderBottom: '0px !important'
		}
	},
	accordionDetails: {
		'& > div': {
			borderRadius: '3px',
			border: '0px'
		}
	},
	chipStyle: {
		position: 'absolute',
		right: '5rem',
		backgroundColor: 'white !important'
	}
}));
